import { Component, Directive, forwardRef, Attribute, OnChanges, SimpleChanges, Input, OnInit, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, NG_VALIDATORS, Validator, AbstractControl, ValidatorFn } from '@angular/forms';

import { UserService } from '../../../_services/user.service';
import { EqualValidatorDirective } from '../../../_directives/equal-validator.directive';

@Component({
    selector: 'app-changepassword',
    templateUrl: './changepassword.component.html',
    styleUrls: ['./changepassword.component.css']
})
export class ChangePasswordComponent implements OnInit {

    loading: boolean;
    message: string;
    model: any = {};
    focusEventEmitter = new EventEmitter<boolean>();
    
    constructor(private userService: UserService) { }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.focusEventEmitter.emit(true);
    }
    
    changePassword() {
        this.loading = true;
        this.userService.changePassword(this.model).subscribe(data => {

            if (data.error) {
                this.message = data.message;
            }
            else {
                this.message = "保存成功！";
            }
        }, error => {
            this.message = error.json().message;

        }, () => {
            this.loading = false;
        })
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/user/changepassword/changepassword.component.ts